import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

/**
 * SwitchRoutes
 *
 * @return {JSX.Element}
 */
const SwitchRoutes = ({ routes, saveQuerySearch, skipSwitch }) => {
  const homeRoute = routes.find(({ index }) => index) || routes[0];
  const homePath = homeRoute.path;
  const { search } = useLocation();
  const homePathFinal = `${homePath}${saveQuerySearch ? search : ''}`;

  const routesRendered = routes.map(
    ({ path, component: Component, hasChild }) => {
      return (
        <Route
          key={path}
          path={`${path}${hasChild ? '/*' : ''}`}
          element={<Component />}
        />
      );
    }
  );

  if (skipSwitch) {
    return routesRendered;
  }

  console.log(homePathFinal);

  return (
    <Routes>
      {routesRendered}
      <Route path="*" element={<Navigate to={homePathFinal} replace />} />
    </Routes>
  );
};

SwitchRoutes.displayName = 'SwitchRoutes';

export default SwitchRoutes;
